// File: /src/services/dashboardService.js
import axios from "axios";
import { Base_URL } from "../url";

// Fetch company codes for an organization
export const fetchCompanyCodes = async (organisationId, token) => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectViewDashboard/company-codes`, {
      params: {
        OrganisationID: organisationId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching company codes:", error);
    throw error;
  }
};

export const fetchPDashboardData = async (filters, user, token) => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectViewDashboard/projects`, {
      params: {
        OrganisationID: user?.organisation_id || filters.OrganisationID,
        CompanyCode: filters.companyCode || null,
        FiscalYear: filters.fiscalYear || null,
        FiscalMonth: filters.fiscalMonth || null
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

